import React, { useState, useEffect } from 'react';
import './PayrollTable.css';

const API = '/api/payroll';

export default function Advances() {
  const [items, setItems]         = useState([]);
  const [employees, setEmployees] = useState([]);
  const [hotels, setHotels]       = useState([]);
  const [periods, setPeriods]     = useState([]);
  const [filter, setFilter]       = useState({ hotel_id: '', period_id: '' });
  const [form, setForm]           = useState({ obj_val: '', employee_id: '', hotel_id: null, period_id: '', amount: '', description: '', adj_date: '' });
  const [showForm, setShowForm]   = useState(false);
  const [loading, setLoading]     = useState(false);

  useEffect(() => { loadRefs(); }, []);
  useEffect(() => { loadItems(); }, [filter]);

  async function loadRefs() {
    const [h, p] = await Promise.all([
      fetch(`${API}/hotels-and-depts`).then(r => r.json()),
      fetch(`${API}/periods`).then(r => r.json()),
    ]);
    setHotels(Array.isArray(h) ? h : (h.hotels || []));
    setPeriods(Array.isArray(p) ? p : []);
  }

  async function loadItems() {
    let url = `${API}/adjustments?`;
    if (filter.hotel_id)  url += `hotel_id=${filter.hotel_id}&`;
    if (filter.period_id) url += `period_id=${filter.period_id}`;
    let data = await fetch(url).then(r => r.json());
    // Авансы — это корректировки с category = 'advance'
    data = (Array.isArray(data) ? data : []).filter(d => d.category === 'advance');
    setItems(data);
  }

  async function loadEmployees(hotelId) {
    if (!hotelId) { setEmployees([]); return; }
    const data = await fetch(`${API}/employees?hotel_id=${hotelId}`).then(r => r.json());
    setEmployees(Array.isArray(data) ? data : []);
  }

  async function save() {
    setLoading(true);
    const body = {
      employee_id: parseInt(form.employee_id),
      hotel_id: form.hotel_id,
      period_id: form.period_id ? parseInt(form.period_id) : null,
      category: 'advance',
      amount: -Math.abs(parseFloat(form.amount)), // аванс всегда минус
      description: form.description || 'Аванс',
      adj_date: form.adj_date || null,
    };
    await fetch(`${API}/adjustments`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    setShowForm(false);
    setForm({ obj_val: '', employee_id: '', hotel_id: null, period_id: '', amount: '', description: '', adj_date: '' });
    setEmployees([]);
    loadItems(); setLoading(false);
  }

  async function remove(id) {
    if (!window.confirm('Удалить аванс?')) return;
    await fetch(`${API}/adjustments/${id}`, { method: 'DELETE' });
    loadItems();
  }

  const total = items.reduce((acc, i) => acc + Math.abs(parseFloat(i.amount || 0)), 0);

  return (
    <div className="pt-page">
      <div className="pt-header">
        <h2>Авансы</h2>
        <button className="btn-primary" onClick={() => setShowForm(true)}>+ Добавить аванс</button>
      </div>

      <div className="stat-cards">
        <div className="stat-card">
          <div className="label">Итого авансов</div>
          <div className="value red">−{total.toLocaleString()} ₽</div>
        </div>
        <div className="stat-card">
          <div className="label">Записей</div>
          <div className="value" style={{ fontSize:22 }}>{items.length}</div>
        </div>
      </div>

      <div className="pt-filters">
        <select value={filter.hotel_id} onChange={e => setFilter(f => ({ ...f, hotel_id: e.target.value }))}>
          <option value="">Все отели</option>
          {hotels.map(h => <option key={h.id} value={h.id}>{h.name}</option>)}
        </select>
        <select value={filter.period_id} onChange={e => setFilter(f => ({ ...f, period_id: e.target.value }))}>
          <option value="">Все периоды</option>
          {periods.map(p => (
            <option key={p.id} value={p.id}>
              {p.hotel_name} — {new Date(p.date_from).toLocaleDateString('ru')} – {new Date(p.date_to).toLocaleDateString('ru')}
            </option>
          ))}
        </select>
      </div>

      <table className="pt-table">
        <thead>
          <tr><th>Сотрудник</th><th>Объект</th><th>Сумма</th><th>Описание</th><th>Дата</th><th></th></tr>
        </thead>
        <tbody>
          {items.length === 0 && (
            <tr><td colSpan={6} style={{ textAlign:'center', color:'#9ca3af', padding:40 }}>Авансов нет</td></tr>
          )}
          {items.map(i => (
            <tr key={i.id}>
              <td><strong style={{ color:'#111827' }}>{i.full_name}</strong></td>
              <td style={{ color:'#6b7280' }}>{i.hotel_name}</td>
              <td style={{ fontWeight:600, color:'#dc2626' }}>−{Math.abs(parseFloat(i.amount)).toLocaleString()} ₽</td>
              <td style={{ color:'#374151' }}>{i.description || '—'}</td>
              <td style={{ color:'#6b7280', fontSize:13 }}>{i.adj_date ? new Date(i.adj_date).toLocaleDateString('ru') : '—'}</td>
              <td><button className="btn-icon danger" onClick={() => remove(i.id)}>✕</button></td>
            </tr>
          ))}
        </tbody>
      </table>

      {showForm && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <h3>Новый аванс</h3>
              <button className="btn-icon" onClick={() => setShowForm(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-row">
                <label>Отель *</label>
                <select value={form.obj_val} onChange={e => {
                  const id = e.target.value;
                  setForm(f => ({ ...f, obj_val: id, hotel_id: id ? parseInt(id) : null, employee_id: '' }));
                  loadEmployees(id);
                }}>
                  <option value="">— выберите отель —</option>
                  {hotels.map(h => <option key={h.id} value={h.id}>{h.name}</option>)}
                </select>
              </div>
              <div className="form-row">
                <label>Сотрудник *</label>
                <select value={form.employee_id} onChange={e => setForm(f => ({ ...f, employee_id: e.target.value }))} disabled={!form.hotel_id}>
                  <option value="">— выберите сотрудника —</option>
                  {employees.map(e => <option key={e.id} value={e.id}>{e.full_name}</option>)}
                </select>
              </div>
              <div className="form-row">
                <label>Период</label>
                <select value={form.period_id} onChange={e => setForm(f => ({ ...f, period_id: e.target.value }))}>
                  <option value="">— без периода —</option>
                  {periods.map(p => (
                    <option key={p.id} value={p.id}>
                      {p.hotel_name} — {new Date(p.date_from).toLocaleDateString('ru')} – {new Date(p.date_to).toLocaleDateString('ru')}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-grid">
                <div className="form-row">
                  <label>Сумма (₽) *</label>
                  <input type="number" min="0" value={form.amount} onChange={e => setForm(f => ({ ...f, amount: e.target.value }))} placeholder="5000" />
                </div>
                <div className="form-row">
                  <label>Дата</label>
                  <input type="date" value={form.adj_date} onChange={e => setForm(f => ({ ...f, adj_date: e.target.value }))} />
                </div>
              </div>
              <div className="form-row">
                <label>Описание</label>
                <input value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} placeholder="Аванс за июль" />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn-secondary" onClick={() => setShowForm(false)}>Отмена</button>
              <button className="btn-primary" onClick={save} disabled={loading || !form.employee_id || !form.amount}>
                {loading ? 'Сохраняем...' : 'Сохранить'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
